import { render, staticRenderFns } from "./GuaranteeRes.vue?vue&type=template&id=4f05b912&scoped=true"
import script from "./GuaranteeRes.vue?vue&type=script&lang=js"
export * from "./GuaranteeRes.vue?vue&type=script&lang=js"
import style0 from "./GuaranteeRes.vue?vue&type=style&index=0&id=4f05b912&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f05b912",
  null
  
)

export default component.exports